import { Icon } from 'components/Library'

const IconInfo = (props) => {
  return (
    <Icon stroke="currentColor" fill="currentColor" strokeWidth={0} viewBox="0 0 64 64" {...props}>
      <defs id="defs495" />
      <path
        id="circle73"
        className="cls-5"
        d="m 31.900776,12.81651 a 4.2986811,4.2956398 0 0 0 -1.421875,0.291016 4.3556173,4.3525357 0 0 0 -2.714843,4.570312 c 0.313148,2.958584 0.608173,5.918087 0.902343,8.867188 0.332127,3.252545 0.645559,6.503315 0.949219,9.755859 0,0.331893 0.169826,0.484093 0.501953,0.47461 0.673745,-0.0095 1.291672,0 1.917969,0 h 1.869141 c 0.332126,0 0.473761,-0.123186 0.511718,-0.455078 0.30366,-3.129271 0.626581,-6.257448 0.949219,-9.386719 0.322639,-3.129271 0.617091,-6.154471 0.949219,-9.236328 A 4.4030641,4.3999489 0 0 0 35.62148,14.738385 4.2986811,4.2956398 0 0 0 31.900776,12.81651 Z m 1.572266,29.123047 a 4.7446811,4.7413242 0 0 0 -6.210938,4.507813 4.7446811,4.7413242 0 0 0 4.751954,4.738281 4.7446811,4.7413242 0 0 0 1.458984,-9.246094 z"
      />
    </Icon>
  )
}

export default IconInfo
